import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SERVICES } from "../lib/site";
import { Seo } from "../components/Seo";

export default function Services() {
  return (
    <div data-testid="page-services">
      <Seo
        path="/services"
        title="Services — Diagnostics, Tuning, Engine, Brakes, Maintenance"
        description="Manufacturer-grade diagnostics (ISTA, ODIS, Star, SSM4, PIWIS), performance tuning (Cobb, APR, MHD), engine & transmission rebuilds, brakes, suspension and scheduled maintenance for European and Subaru imports."
      />
      <PageHeader
        code="// 02"
        kicker="Services"
        title={<>What we<br />actually do.</>}
        subtitle="Five focused services. We don't sell packages, upsells or fear — and every job is backed by our 12-month / 12,000-mile warranty and photo documented start to finish."
        testId="services-header"
      />

      <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="space-y-6">
          {SERVICES.map((s, i) => (
            <article
              key={s.code}
              data-testid={`service-row-${s.code}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border border-white/10 bg-[#0A0A0A] hover:bg-[#1A1F24] transition-colors p-6 md:p-10"
            >
              <div className="md:col-span-2 flex md:flex-col items-baseline md:items-start gap-3 md:gap-6">
                <span className="font-display font-black text-6xl md:text-7xl text-[#FF3B30] leading-none">{s.code}</span>
                <span className="font-mono-tech text-[10px] text-white/40 tracking-[0.3em] uppercase">Service</span>
              </div>
              <div className="md:col-span-6">
                <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-4xl leading-[0.9]">{s.title}</h2>
                <p className="mt-4 text-white/70 leading-relaxed text-base md:text-lg max-w-2xl">{s.desc}</p>
              </div>
              <div className="md:col-span-4">
                <ul className="space-y-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-white/80 text-sm">
                      <span className="mt-0.5 w-5 h-5 grid place-items-center bg-[#FF3B30]/15 text-[#FF3B30] shrink-0">
                        <Check className="w-3 h-3" strokeWidth={3} />
                      </span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-center bg-[#1A1F24] border border-white/10 p-8 md:p-12">
          <div className="md:col-span-8">
            <div className="font-mono-tech text-[11px] text-[#FF3B30] tracking-[0.3em] uppercase">// pricing</div>
            <h3 className="font-display font-black uppercase tracking-tighter text-3xl md:text-4xl mt-2 leading-[0.95]">
              No flat-rate menu.<br />Real quotes, fast.
            </h3>
            <p className="text-white/65 mt-4 max-w-xl">
              Send us your VIN, the issue (or your last scan report) and we'll come back with an honest written quote — usually inside a business day.
            </p>
          </div>
          <div className="md:col-span-4 flex md:justify-end">
            <Link
              to="/contact"
              data-testid="services-quote-cta"
              className="group inline-flex items-center gap-3 bg-[#FF3B30] hover:bg-[#FF5722] text-white text-xs font-bold uppercase tracking-[0.25em] px-7 py-4 transition-colors"
            >
              Request a quote
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
